import {AddToCartFormatModel} from "./add-to-cart-format.model";

export class AddMultipleFormatsToCartModel {
    public constructor(
        public productId: number,
        public formats: Array<AddToCartFormatModel> = new Array<AddToCartFormatModel>(),
        public regionId: number = null
    ) {
    }
}
